// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BankTransaction } from './bank-transaction';
import { Contribution } from './contribution';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OnlineContribution extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  assignedMonth?: Date;
  bankTransactionId?: number;
  batchId!: number;
  contributionId?: number;
  created?: Date;
  currentMonth!: boolean;
  deleted?: Date;
  donationDate!: Date;
  donorCoversFees?: string;
  donorId!: number;
  donorName?: string;
  frequency?: string;
  fund?: string;
  grossGift?: number;
  nextMonth!: boolean;
  notes?: string;
  paymentSource?: string;
  personId?: number;
  processed?: Date;
  recurringGift?: string;
  status?: string;
  bankTransaction!: BankTransaction;
  contribution!: Contribution;
}

